kombi.closeOffcanvas = function(offcanvasId) {
    const offcanvasElement = document.getElementById(offcanvasId);
    const offcanvasInstance = offcanvasElement && bootstrap.Offcanvas.getInstance(offcanvasElement);
    if (offcanvasInstance) {
        offcanvasInstance.hide();
    }
};
